<template>
  <div class="navigator" :count="count">
    <div class="item" v-for="(item,index) in showItems" :key="item.title + index" @click="goto(item.link)">
      <img :src="item.image" />
      <div v-if="showTitle" :style="{color:textColor}">{{item.title}}</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    showItems: function() {
      return this.items.slice(0, this.count).map((item) => {
        return {image:item.image, link: item.link,title:this.formatTitle(item.title)}
      });
    }
  },
  props: {
    count: {
      type: Number,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    textColor: {
      type: String,
      default: "#333333"
    },
    items: {
      type: Array,
      required: true
    }
  },
  methods:{
    formatTitle(title){
      return title.substring(0,5)
    },
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.navigator {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // padding: 0 18px;
    img{
      max-width: 55px;
      max-height: 55px;
    }
}
.item{
    display: flex;
    flex-direction: column;
    align-items: center;
    flex : 1 1;
    font-weight: 400;
}

.navigator[count='3'] {
    justify-content: space-around;
    .item{
        font-size: 14px;
        img{
            height: 14vw;
            width: 14vw;
        }
        img + div{
            margin-top: 8px;
        }
    }
}

.navigator[count='4'] {
    .item{
        font-size: 14px;
        img{
            height: 14vw;
            width: 14vw;
        }
        img + div{
            margin-top: 6px;
        }
    }
}

.navigator[count='5'] {
    .item{
        font-size: 12px;
        img{
            height: 14vw;
            width: 14vw;
        }
        img + div{
            margin-top: 4px;
        }
    }
}
</style>
